module.exports = __webpack_public_path__ + "img/icon-approved.1492639a.svg";